import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { AuthProvider } from "context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Set dark mode before React renders
const userPref = localStorage.getItem("theme");
const systemPref = window.matchMedia("(prefers-color-scheme: dark)").matches;
if (userPref === "dark" || (!userPref && systemPref)) {
  document.body.classList.add("dark");
} else {
  document.body.classList.remove("dark");
}
root.render(
  <AuthProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);
